import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { supertokenRevoke } from "../../../utilities/API/supertokenServices"
import { toast } from "react-toastify"

export const supertokenRevokeService = createAsyncThunk(
    'fetchPreAuthFAF', supertokenRevoke
)

const initialState = {
    loader: false
}

const supertokenRevokeSlice = createSlice({
    name: 'preAuth',
    initialState,
    reducers: {
        resetSupertokenRevoke: (state) => {
            state.loader = false
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(supertokenRevokeService.pending, (state, action) => {
                state.loader = true
            })
            .addCase(supertokenRevokeService.fulfilled, (state, action) => {
                state.loader = false
            })
            .addCase(supertokenRevokeService.rejected, (state, action) => {
                toast.error(action.error.message)
                state.loader = false
            })
    }
})

export const { resetSupertokenRevoke } = supertokenRevokeSlice.actions

export default supertokenRevokeSlice.reducer

